/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetOrdersReportQueryParams, GetOrdersReport200, GetOrdersReport400, GetOrdersReportQueryResponse } from '../entities/GetOrdersReport'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

export const getOrdersReportQueryParamsSchema = z
  .object({
    drivee_city_id: z.number().int().optional(),
    from_address: z.string().optional(),
    from_date: z.string().optional(),
    payment_method: z.array(z.enum(['cash', 'card'])).optional(),
    phone: z.string().optional(),
    status: z.array(z.enum(['process', 'done', 'cancel'])).optional(),
    to_address: z.string().optional(),
    to_date: z.string().optional(),
  })
  .optional() as unknown as ToZod<GetOrdersReportQueryParams>

/**
 * @description Binary file
 */
export const getOrdersReport200Schema = z.instanceof(File) as unknown as ToZod<GetOrdersReport200>

/**
 * @description Bad Request
 */
export const getOrdersReport400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetOrdersReport400>

export const getOrdersReportQueryResponseSchema = z.lazy(() => getOrdersReport200Schema) as unknown as ToZod<GetOrdersReportQueryResponse>